export default{
  notifications: state => Array.from(state.notifications.values()).sort((a,b)=>new Date(b.timestamp)-new Date(a.timestamp)),
  newNotificationCount: state => state.newNotificationCount,
  hasMoreNotification: state => state.hasMoreNotification,
  notificationPage: state => state.notificationPage,
}